/* <hero-phone>: plays the hero montage inside the phone mockup.
 * - Picks the source: HLS where the browser supports it (Safari/iOS), else a 480p or 720p MP4 by screen size.
 * - Starts only when the phone is on screen, pauses when it scrolls away.
 * - Respects reduced motion: no autoplay, tap the video to play.
 * - Sound button toggles mute.
 * A custom element so it re-initialises when the theme editor re-renders the section.
 */
(function () {
  if (window.customElements && customElements.get('hero-phone')) return;

  class HeroPhone extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.soundButton = this.querySelector('.hero-v2__phone-sound');
      if (!this.video) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userStarted = false;

      const src = this.pickSource();
      if (!src) return;
      this.video.src = src;
      this.video.preload = 'metadata';

      this.video.addEventListener('click', () => this.togglePlay());
      if (this.soundButton) this.soundButton.addEventListener('click', () => this.toggleSound());

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => (entry.isIntersecting ? this.autoPlay() : this.video.pause()));
        }, { threshold: 0.25 });
        this.observer.observe(this);
      } else {
        this.autoPlay();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    pickSource() {
      const d = this.video.dataset;
      const canHls = this.video.canPlayType('application/vnd.apple.mpegurl') !== '';
      if (canHls && d.srcHls) return d.srcHls;
      const small = window.matchMedia('(max-width: 767px)').matches;
      if (small && d.srcSmall) return d.srcSmall;
      return d.srcLarge || d.srcSmall || d.srcFallback || '';
    }

    autoPlay() {
      if (this.reducedMotion && !this.userStarted) return;
      const attempt = this.video.play();
      if (attempt && attempt.catch) attempt.catch(() => {});
    }

    togglePlay() {
      this.userStarted = true;
      if (this.video.paused) this.autoPlay();
      else this.video.pause();
    }

    toggleSound() {
      this.video.muted = !this.video.muted;
      const on = !this.video.muted;
      this.soundButton.setAttribute('aria-pressed', String(on));
      this.soundButton.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
      if (on) {
        this.userStarted = true;
        this.autoPlay();
      }
    }
  }

  customElements.define('hero-phone', HeroPhone);
})();
